<template>
    <b-modal
        id="class-link-modal"
        ref="class-link-modal"
        size="lg"
        :title="$t('slu_dashboard.select_groups')"
        modal-class="apprentice-default-modal"
        header-class="header"
        ok-only
        :ok-title="$t('common.close')">
        <design-2021-apprentice-data-table
            class="las-groups"
            :items="tableData"
            :fields="groupFields">
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-add btn-add-group-to-cohort btn-"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('common.add')"
                    @click="addGroup(data.item)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-slu-cohort-link-class-modal-component',
    props: ['lasGroupsIn', 'lasMainGroupsIn', 'sluCohortIn'],
    data() {
        return {
            sluCohort: this.sluCohortIn,
            lasGroups: this.lasGroupsIn,
            lasMainGroups: this.lasMainGroupsIn,
            groupFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'type',
                    label: 'Type',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            let groups = this.lasGroupsIn
                .filter((group) => {
                    return !this.sluCohort.las_groups.find((activeGroup) => activeGroup.id === group.id);
                })
                .map((group) => {
                    group.type = this.$t('slu_dashboard.lesson_group');
                    return group;
                });
            let filteredMainGroups = this.lasMainGroupsIn.filter((group) => {
                return !this.sluCohort.las_main_groups.find((activeGroup) => activeGroup.id === group.id);
            });
            let mainGroups = filteredMainGroups.map((group) => {
                if (this.sluCohort.las_main_groups.find((activeGroup) => activeGroup.id === group.id)) {
                    return;
                }
                group.type = this.$t('slu_dashboard.main_group');
                return group;
            });
            return groups.concat(mainGroups);
        },
    },
    methods: {
        addGroup(group) {
            let type;
            if (group.type === this.$t('slu_dashboard.lesson_group')) {
                type = 'lasGroup';
            } else {
                type = 'lasMainGroup';
            }
            let data = {
                id: group.id,
                type: type,
            };
            this.alert.saving();
            this.axios
                .post(this.routes.sluCohortAddLasGroup(this.sluCohortIn.slu_course_id, this.sluCohortIn.id), data)
                .then(
                    (response) => {
                        this.sluCohort = response.data;
                        this.$emit('updateCohort', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
    },
};
</script>

<style scoped></style>
